var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { SystemProgram } from "@solana/web3.js";
import { findOrCreateAta } from "../../utils/findOrCreateAta.function";
import { TOKEN_PROGRAM_ID } from "@solana/spl-token";
import { errorIfInsufficientBalance } from "../../utils/errorIfInsufficientBalance.function";
export function getDepositSolInstruction(Data) {
    return __awaiter(this, void 0, void 0, function () {
        var instructions, swapDataAccountAta, signerAta, newAtas, _a, userAta, userAtaIx, _b, pdaAta, pdaAtaIx, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0: return [4 /*yield*/, errorIfInsufficientBalance({
                        amount: Data.amount,
                        connection: Data.program.provider.connection,
                        mint: Data.mint,
                        owner: Data.signer,
                    })];
                case 1:
                    _e.sent();
                    instructions = [];
                    swapDataAccountAta = Data.swapIdentity.swapDataAccount_publicKey;
                    signerAta = Data.signer;
                    newAtas = Data.ataList;
                    if (!!Data.mint.equals(SystemProgram.programId)) return [3 /*break*/, 4];
                    return [4 /*yield*/, findOrCreateAta({
                            connection: Data.program.provider.connection,
                            owner: Data.signer,
                            mint: Data.mint,
                            signer: Data.signer,
                        })];
                case 2:
                    _a = _e.sent(), userAta = _a.mintAta, userAtaIx = _a.instruction;
                    signerAta = userAta;
                    if (userAtaIx && !Data.ataList.includes(userAta)) {
                        instructions.push(userAtaIx);
                        newAtas.push(userAta);
                        console.log("createUserAta DepositSol Tx Added", userAta.toBase58());
                    }
                    return [4 /*yield*/, findOrCreateAta({
                            connection: Data.program.provider.connection,
                            owner: Data.swapIdentity.swapDataAccount_publicKey,
                            mint: Data.mint,
                            signer: Data.signer,
                        })];
                case 3:
                    _b = _e.sent(), pdaAta = _b.mintAta, pdaAtaIx = _b.instruction;
                    swapDataAccountAta = pdaAta;
                    if (pdaAtaIx && !Data.ataList.includes(pdaAta)) {
                        instructions.push(pdaAtaIx);
                        newAtas.push(pdaAta);
                        console.log("createPdaAta DepositSol Tx Added", pdaAta.toBase58());
                    }
                    _e.label = 4;
                case 4:
                    _d = (_c = instructions).push;
                    return [4 /*yield*/, Data.program.methods
                            .depositSol(Data.swapIdentity.swapDataAccount_seed)
                            .accounts({
                            systemProgram: SystemProgram.programId.toString(),
                            splTokenProgram: TOKEN_PROGRAM_ID,
                            swapDataAccount: Data.swapIdentity.swapDataAccount_publicKey.toString(),
                            swapDataAccountAta: swapDataAccountAta,
                            signer: Data.signer.toString(),
                            signerAta: signerAta,
                        })
                            .instruction()];
                case 5:
                    _d.apply(_c, [_e.sent()]);
                    return [2 /*return*/, { instructions: instructions, newAtas: newAtas }];
            }
        });
    });
}
